import { Phone, MessageSquare, Users, Database, Zap, Globe, Languages, Network, Shield, Award, TrendingUp } from 'lucide-react';

export const mockData = {
  stats: [
    { value: '200K', label: 'Agent Hours Saved' },
    { value: '99%', label: 'Improvement in FRT' },
    { value: '3x', label: 'Repeat Customers' },
    { value: '125%', label: 'Improvement in NPS' }
  ],

  trustedCompanies: [
    'Enterprise A', 'Enterprise B', 'Enterprise C', 'Enterprise D', 'Enterprise E',
    'Enterprise F', 'Enterprise G', 'Enterprise H', 'Enterprise I', 'Enterprise J'
  ],

  agents: [
    {
      name: 'AI Voice Agent',
      description: 'Elevate CX with natural voice conversations'
    },
    {
      name: 'AI Customer Service Agent',
      description: 'Streamline support without pre-built journeys'
    },
    {
      name: 'AI Sales Agent',
      description: 'Enable smart purchases with tailored recommendations'
    },
    {
      name: 'AI Booking Agent',
      description: 'Drive bookings and reservations with ease'
    },
    {
      name: 'AI Lead Qualification Agent',
      description: 'Capture qualified leads for personalized engagement'
    }
  ],

  voiceFeatures: [
    {
      icon: Phone,
      title: 'Voice-First AI for Natural Conversations',
      description: 'Give your customers the freedom to express themselves naturally—anytime, anywhere'
    },
    {
      icon: Users,
      title: 'Effortless Assistance, Hands-Free',
      description: 'Let customers speak instead of typing, making interactions faster, smoother, and more personal'
    },
    {
      icon: Network,
      title: 'Dynamic Call Routing',
      description: 'Route calls based on their actual need rather than rigid menu options, driving faster resolution and higher customer satisfaction'
    },
    {
      icon: MessageSquare,
      title: 'An Empathetic, Intelligent Listener',
      description: 'Your AI Agent doesn\'t just hear—it understands, responds, and solves problems with care'
    }
  ],

  builderFeatures: [
    {
      icon: Zap,
      title: 'Flexible Model Selection',
      description: 'Experiment with leading AI models like GPT, Llama, and Claude to find the best fit for your business needs'
    },
    {
      icon: Globe,
      title: 'Omnichannel Engagement',
      description: 'Deploy your AI Agent across Web, Chat, Voice, and more—effortlessly reaching customers on their preferred platforms'
    },
    {
      icon: Languages,
      title: 'Multilingual Support',
      description: 'Break language barriers with AI that converses in 100+ languages, ensuring seamless global communication'
    }
  ],

  dataFeatures: [
    {
      icon: Database,
      title: 'Leverage Your Enterprise Data',
      description: 'Fine-tune your AI agent using your enterprise knowledge base—PDFs, DOCX, PPTX, CSVs, and even your website'
    },
    {
      icon: Zap,
      title: 'Maximum Accuracy',
      description: 'Improve AI agents\' accuracy by combining multiple RAG systems for easy information retrieval from documents and websites'
    },
    {
      icon: TrendingUp,
      title: 'Smart Recommendations',
      description: 'Accurately recommend products to customers using insights from your product catalog'
    }
  ],

  corePillars: [
    {
      icon: Globe,
      title: 'Leverage the Web, with Control',
      description: 'Make your AI infinitely smarter by leveraging real-time information from the web to answer brand and industry-related queries— with clear boundaries ensuring it stays on-brand'
    },
    {
      icon: Zap,
      title: 'Optimize Costs with Smart LLM Calls',
      description: 'Our advanced caching system minimizes unnecessary LLM calls for optimal performance, delivering lightning-fast responses while keeping costs in check as you scale'
    },
    {
      icon: Network,
      title: 'Seamlessly Orchestrate Multiple Systems',
      description: 'Unify disconnected tools and databases into a single, intelligent workflow—cutting turnaround time by 70% and maximizing efficiency through effective integrations'
    },
    {
      icon: Zap,
      title: 'Power Multi-Step Actions',
      description: 'Empower users to accomplish more in one go. Let them instruct your AI to perform multiple actions in a single command—boosting automation and user satisfaction'
    }
  ],

  advantages: [
    {
      icon: Award,
      title: 'Decade of AI Expertise',
      description: 'A decade of building custom conversational AI for enterprises, now evolving into LLM-driven AI Agents for retail, eCommerce, fintech, and more'
    },
    {
      icon: Shield,
      title: 'Robust Security',
      description: 'Blue Vantage\'s AI Agent platform complies with ISO, GDPR, CCPA, CPRA, and other international standards, independently audited for your peace of mind'
    },
    {
      icon: Users,
      title: 'Strategic Partners',
      description: 'As strategic partners of leading AI providers, we offer priority access to cutting-edge AI features, reducing training time and unlocking new capabilities faster'
    }
  ],

  testimonials: [
    {
      name: 'John Smith',
      position: 'CEO, TechCorp',
      quote: 'Working with Blue Vantage has transformed our customer experience. Their AI agents have helped us scale support while maintaining the personal touch our customers love.'
    },
    {
      name: 'Sarah Johnson',
      position: 'Head of Customer Success, RetailPro',
      quote: 'The multilingual capabilities and seamless integration made Blue Vantage the perfect choice for our global operations. We\'ve seen a 200% improvement in customer satisfaction.'
    },
    {
      name: 'Michael Chen',
      position: 'CTO, FinanceFirst',
      quote: 'Security and compliance were our top priorities. Blue Vantage delivered a robust solution that met all our requirements while exceeding our performance expectations.'
    },
    {
      name: 'Emily Rodriguez',
      position: 'VP Operations, HealthCare Plus',
      quote: 'The AI voice agents have revolutionized how we handle patient inquiries. The natural conversations and empathetic responses have been game-changing for our service quality.'
    },
    {
      name: 'David Omondi',
      position: 'Director of Digital, EastAfrica Telecom',
      quote: 'Blue Vantage understood our unique African market needs and delivered a solution that works seamlessly across all our countries. Their local presence made all the difference.'
    }
  ],

  recognition: [
    'G2 Leader 2025',
    'Best AI Platform',
    'Enterprise Ready',
    'ISO Certified',
    'Top Rated 2025'
  ],

  blogPosts: [
    {
      title: 'The Future of Customer Experience: AI Agents Leading the Way',
      excerpt: 'Discover how AI agents are transforming customer interactions and setting new standards for service excellence in 2025.'
    },
    {
      title: 'Multilingual AI: Breaking Down Language Barriers in Africa',
      excerpt: 'Learn how multilingual AI agents are enabling businesses to serve diverse African markets with personalized, localized experiences.'
    },
    {
      title: 'ROI of AI Agents: Measuring Real Business Impact',
      excerpt: 'A comprehensive guide to understanding and measuring the return on investment from implementing AI-powered customer service agents.'
    }
  ]
};